export const handleWaLink = (link, phone = '') => {
    // is mobile.. 61994181556
    const number = phone !== '' ? `phone=${phone}` : ''
    let msg
    if (number == '') {
         msg = link ? `text=${link}` : ''
    } else {
        msg = link ? `&text=${link}` : ''
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return `https://api.whatsapp.com/send?${number}${msg}`
    } else {
        return `https://web.whatsapp.com/send?${number}${msg}`
    }
}
